import {
  HttpInterceptorFn,
  HttpHandlerFn,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { inject } from '@angular/core';
import { AuthService } from 'libs/shared/auth/services/src';

export const httpInterceptor = (): HttpInterceptorFn => {
  return (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const { url } = req;

    let interceptorUrl = environment.url;

    // Control de URL's para cuando cargarmos internamente los templates
    if (url.startsWith('assets/templates')) {
      interceptorUrl = '';
    }

    const hasWWW = window.location.origin.includes('www.');
    if (hasWWW) {
      const urlParts = environment.url.split('://');
      if (urlParts.length === 2 && !urlParts[1].startsWith('www.')) {
        environment.url = `${urlParts[0]}://www.${urlParts[1]}`;
      }
    }
    const authService = inject(AuthService);

    let authReq = req.clone({
      url: `${interceptorUrl}${url}`,
      withCredentials: true,
    });

    const token = authService.getToken();
    if (token) {
      authReq = authReq.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    return next(authReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          authService.logout();
        }
        return throwError(() => err);
      })
    );
  };
};
